import React from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  Button,
  Alert,
} from '@mui/material';
import { Telegram, Psychology } from '@mui/icons-material';

const TelegramOnlyScreen: React.FC = () => {
  const botUsername = import.meta.env.VITE_TELEGRAM_BOT_USERNAME || 'ads_integrator_bot';
  
  const handleOpenTelegram = () => {
    // Попытка открыть Telegram (работает на мобильных устройствах)
    window.open(`https://t.me/${botUsername}`, '_blank');
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4, minHeight: '100vh', display: 'flex', alignItems: 'center', backgroundColor: '#ffffff' }}>
      <Card 
        elevation={0}
        sx={{ 
          width: '100%',
          textAlign: 'center',
          p: 3,
          borderRadius: 3,
          boxShadow: 'none',
          background: '#ffffff',
          color: '#000000',
        }}
      >
        <CardContent>
          <Box
            component="img"
            src="/logo_ads.jpg"
            alt="Logo"
            sx={{
              width: 100,
              height: 100,
              margin: '0 auto 24px',
              objectFit: 'contain',
            }}
          />

          <Typography variant="h4" component="h1" gutterBottom fontWeight="bold" color="text.primary" sx={{ mb: 3 }}>
            Быстрый запуск рекламы
          </Typography>

          <Alert 
            severity="info" 
            icon={false}
            sx={{ 
              mb: 3,
              justifyContent: 'center',
              '& .MuiAlert-message': {
                textAlign: 'center',
              },
            }}
          >
            <Typography variant="body1" fontWeight="500">
              Доступ разрешён только из Telegram
            </Typography>
          </Alert>

          <Button
            variant="contained"
            size="large"
            startIcon={<Telegram />}
            onClick={handleOpenTelegram}
            sx={{
              fontWeight: 'bold',
              py: 1.5,
              px: 4,
              backgroundImage: 'linear-gradient(100deg, rgb(64, 221, 255) -6.08%, rgb(118, 18, 250) 25.08%, rgb(250, 18, 227))',
              color: '#ffffff',
              '&:hover': {
                backgroundImage: 'linear-gradient(100deg, rgb(64, 221, 255) -6.08%, rgb(118, 18, 250) 25.08%, rgb(250, 18, 227))',
                opacity: 0.9,
              },
            }}
          >
            Открыть в Telegram
          </Button>

          <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
              <Psychology sx={{ fontSize: 16 }} />
              Запускайте рекламу за минуты
            </Typography>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default TelegramOnlyScreen; 